/**
 * @Description: 表情包组件
 * @author Shi_qshan
 * @date 2022/2/18
 */

import React, {useState} from "react";

import emoji from "../../image/emoji/emoji.png"
import {Carousel, Popover, Tooltip} from "antd";


const ImEmoji = (props) => {

    const [visible, setVisible] = useState(false)

    function selectImg(obj) {
        //关闭 Popover层， 返回选中的表情
        setVisible(false)
        props.getEmoji(obj)
    }

    function handleVisibleChange(value) {
        setVisible(value)
    }

    const content = (
        <div className={'emoji-content'}>
        <Carousel className={'cloud-dots'}>
            <div className={'emoji-content'}>
                {
                    page1.map((item,index) => (
                        <div key={index} className={'earch-emoji'} onClick={() => selectImg(item)}>
                            <img src={item.url}/>
                        </div>
                    ))
                }
            </div>

            <div className={'emoji-content'}>
                {
                    page2.map((item,index) => (
                        <div key={index} className={'earch-emoji'} onClick={() => selectImg(item)}>
                            <img src={item.url}/>
                        </div>
                    ))
                }
            </div>

            <div className={'emoji-content'}>
                {
                    page3.map((item,index) => (
                        <div key={index} className={'earch-emoji'} onClick={() => selectImg(item)}>
                            <img src={item.url}/>
                        </div>
                    ))
                }
            </div>

            <div className={'emoji-content'}>
                {
                    page4.map((item,index) => (
                        <div key={index} className={'earch-emoji'} onClick={() => selectImg(item)}>
                            <img src={item.url}/>
                        </div>
                    ))
                }
            </div>
        </Carousel>
        </div>
    )

    return (
        <>
            <Popover content={content} trigger="click" visible={visible} onVisibleChange={handleVisibleChange}>
                <Tooltip placement="top" title={'表情'}>
                    <img src={emoji} className={'im-emoji'} onClick={() => setVisible(true)}/>
                </Tooltip>
            </Popover>
        </>
    )
}
//4页表情
export const page1 = [
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/001.png',
        text: '[微笑]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/002.png',
        text: '[撇嘴]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/003.png',
        text: '[色]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/004.png',
        text: '[发呆]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/005.png',
        text: '[得意]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/006.png',
        text: '[流泪]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/007.png',
        text: '[害羞]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/008.png',
        text: '[闭嘴]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/009.png',
        text: '[睡]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/010.png',
        text: '[大哭]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/011.png',
        text: '[尴尬]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/012.png',
        text: '[发怒]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/013.png',
        text: '[调皮]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/014.png',
        text: '[呲牙]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/015.png',
        text: '[惊讶]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/016.png',
        text: '[难过]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/017.png',
        text: '[酷]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/018.png',
        text: '[囧]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/019.png',
        text: '[抓狂]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/020.png',
        text: '[吐]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/021.png',
        text: '[偷笑]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/022.png',
        text: '[愉快]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/023.png',
        text: '[白眼]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/024.png',
        text: '[傲慢]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/025.png',
        text: '[饥饿]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/026.png',
        text: '[困]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/027.png',
        text: '[惊恐]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/028.png',
        text: '[流汗]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/029.png',
        text: '[憨笑]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/030.png',
        text: '[悠闲]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/031.png',
        text: '[奋斗]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/032.png',
        text: '[咒骂]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/033.png',
        text: '[疑问]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/034.png',
        text: '[嘘]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/035.png',
        text: '[晕]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/036.png',
        text: '[疯了]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/037.png',
        text: '[衰]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/038.png',
        text: '[骷髅]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/039.png',
        text: '[敲打]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/040.png',
        text: '[再见]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/041.png',
        text: '[擦汗]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/042.png',
        text: '[抠鼻]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/043.png',
        text: '[鼓掌]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/044.png',
        text: '[糗大了]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/045.png',
        text: '[坏笑]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/046.png',
        text: '[左哼哼]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/047.png',
        text: '[右哼哼]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/048.png',
        text: '[哈欠]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/049.png',
        text: '[鄙视]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/050.png',
        text: '[委屈]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/051.png',
        text: '[快哭了]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/052.png',
        text: '[阴险]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/053.png',
        text: '[亲亲]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/054.png',
        text: '[吓]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/055.png',
        text: '[可怜]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/056.png',
        text: '[菜刀]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/057.png',
        text: '[西瓜]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/058.png',
        text: '[啤酒]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/059.png',
        text: '[篮球]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/060.png',
        text: '[乒乓]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/061.png',
        text: '[咖啡]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/062.png',
        text: '[饭]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/063.png',
        text: '[猪头]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/064.png',
        text: '[玫瑰]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/065.png',
        text: '[凋谢]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/066.png',
        text: '[嘴唇]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/067.png',
        text: '[爱心]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/068.png',
        text: '[心碎]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/069.png',
        text: '[蛋糕]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/070.png',
        text: '[闪电]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/071.png',
        text: '[炸弹]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/072.png',
        text: '[刀]'
    },
]
export const page2 = [
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/073.png',
        text: '[足球]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/074.png',
        text: '[瓢虫]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/075.png',
        text: '[便便]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/076.png',
        text: '[月亮]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/077.png',
        text: '[太阳]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/078.png',
        text: '[礼物]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/079.png',
        text: '[拥抱]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/080.png',
        text: '[强]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/081.png',
        text: '[弱]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/082.png',
        text: '[握手]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/083.png',
        text: '[胜利]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/084.png',
        text: '[抱拳]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/085.png',
        text: '[勾引]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/086.png',
        text: '[拳头]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/087.png',
        text: '[差劲]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/088.png',
        text: '[爱你]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/089.png',
        text: '[NO]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/090.png',
        text: '[OK]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/091.png',
        text: '[爱情]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/092.png',
        text: '[飞吻]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/093.png',
        text: '[跳跳]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/094.png',
        text: '[发抖]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/095.png',
        text: '[怄火]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/096.png',
        text: '[转圈]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/106.png',
        text: '[嘿哈]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/107.png',
        text: '[捂脸]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/108.png',
        text: '[奸笑]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/109.png',
        text: '[机智]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/110.png',
        text: '[皱眉]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/111.png',
        text: '[耶]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/112.png',
        text: '[红包]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/113.png',
        text: '[蜡烛]'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/114.png',
        text: '😄'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/115.png',
        text: '😊'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/116.png',
        text: '😃'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/117.png',
        text: '☺'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/118.png',
        text: '😉'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/119.png',
        text: '😍'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/120.png',
        text: '😘'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/121.png',
        text: '😚'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/122.png',
        text: '😳'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/123.png',
        text: '😁'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/124.png',
        text: '😌'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/125.png',
        text: '😜'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/126.png',
        text: '😝'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/127.png',
        text: '😒'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/128.png',
        text: '😏'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/129.png',
        text: '😓'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/130.png',
        text: '😔'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/131.png',
        text: '😞'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/132.png',
        text: '😖'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/133.png',
        text: '😥'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/134.png',
        text: '😰'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/135.png',
        text: '😨'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/136.png',
        text: '😣'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/137.png',
        text: '😢'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/138.png',
        text: '😭'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/139.png',
        text: '😂'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/140.png',
        text: '😲'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/141.png',
        text: '😱'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/142.png',
        text: '😠'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/143.png',
        text: '😡'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/144.png',
        text: '😪'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/145.png',
        text: '😷'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/146.png',
        text: '👿'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/147.png',
        text: '👽'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/148.png',
        text: '❤'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/149.png',
        text: '💔'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/150.png',
        text: '💘'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/151.png',
        text: '✨'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/152.png',
        text: '🌟'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/153.png',
        text: '❕'
    },
]
export const page3 = [
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/154.png',
        text: '❔'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/155.png',
        text: '💤'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/156.png',
        text: '💦'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/157.png',
        text: '🎵'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/158.png',
        text: '🔥'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/159.png',
        text: '💩'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/160.png',
        text: '👍'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/161.png',
        text: '👎'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/162.png',
        text: '👊'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/163.png',
        text: '✌'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/164.png',
        text: '👆'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/165.png',
        text: '👇'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/166.png',
        text: '👉'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/167.png',
        text: '👈'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/168.png',
        text: '☝'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/169.png',
        text: '💪'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/170.png',
        text: '💏'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/171.png',
        text: '💑'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/172.png',
        text: '👦'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/173.png',
        text: '👧'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/174.png',
        text: '👩'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/175.png',
        text: '👨'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/176.png',
        text: '👼'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/177.png',
        text: '💀'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/178.png',
        text: '👄'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/179.png',
        text: '☀'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/180.png',
        text: '☔'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/181.png',
        text: '☁'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/182.png',
        text: '⛄'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/183.png',
        text: '🌙'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/184.png',
        text: '⚡'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/185.png',
        text: '🌊'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/186.png',
        text: '🐱'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/187.png',
        text: '🐶'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/188.png',
        text: '🐭'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/189.png',
        text: '🐹'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/190.png',
        text: '🐰'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/191.png',
        text: '🐺'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/192.png',
        text: '🐸'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/193.png',
        text: '🐯'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/194.png',
        text: '🐨'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/195.png',
        text: '🐷'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/196.png',
        text: '🐮'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/197.png',
        text: '🐗'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/198.png',
        text: '🐮'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/199.png',
        text: '🐵'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/200.png',
        text: '🐴'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/201.png',
        text: '🐍'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/202.png',
        text: '🐦'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/203.png',
        text: '🐔'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/204.png',
        text: '🐧'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/205.png',
        text: '🐛'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/206.png',
        text: '🐙'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/207.png',
        text: '🐠'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/208.png',
        text: '🐳'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/209.png',
        text: '🐬'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/210.png',
        text: '🌹'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/211.png',
        text: '🌺'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/212.png',
        text: '🌴'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/213.png',
        text: '🌵'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/214.png',
        text: '💝'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/215.png',
        text: '🎃'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/216.png',
        text: '👻'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/217.png',
        text: '🎅'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/218.png',
        text: '🎄'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/219.png',
        text: '🎁'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/220.png',
        text: '🔔'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/221.png',
        text: '🎉'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/222.png',
        text: '🎈'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/223.png',
        text: '💿'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/224.png',
        text: '📷'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/225.png',
        text: '🎥'
    },
]
export const page4 = [
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/226.png',
        text: '💻'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/227.png',
        text: '📺'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/228.png',
        text: '☎'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/229.png',
        text: '🔓'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/230.png',
        text: '🔒'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/231.png',
        text: '🔑'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/232.png',
        text: '🔨'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/233.png',
        text: '💡'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/234.png',
        text: '📫'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/235.png',
        text: '🛀'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/236.png',
        text: '💰'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/237.png',
        text: '💣'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/238.png',
        text: '🔫'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/239.png',
        text: '💊'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/240.png',
        text: '🏈'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/241.png',
        text: '🏀'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/242.png',
        text: '⚽'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/243.png',
        text: '⚾'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/244.png',
        text: '⛳'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/245.png',
        text: '🏆'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/246.png',
        text: '👾'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/247.png',
        text: '🎤'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/248.png',
        text: '🎸'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/249.png',
        text: '👙'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/250.png',
        text: '👑'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/251.png',
        text: '🌂'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/252.png',
        text: '👜'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/253.png',
        text: '💄'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/254.png',
        text: '💍'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/255.png',
        text: '💎'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/256.png',
        text: '☕'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/257.png',
        text: '🍺'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/258.png',
        text: '🍻'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/259.png',
        text: '🍸'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/260.png',
        text: '🍔'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/261.png',
        text: '🍟'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/262.png',
        text: '🍝'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/263.png',
        text: '🍣'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/264.png',
        text: '🍜'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/265.png',
        text: '🍳'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/266.png',
        text: '🍦'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/267.png',
        text: '🎂'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/268.png',
        text: '🍎'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/269.png',
        text: '✈'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/270.png',
        text: '🚀'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/271.png',
        text: '🚲'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/272.png',
        text: '🚄'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/273.png',
        text: '⚠'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/274.png',
        text: '🏁'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/275.png',
        text: '🚹'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/276.png',
        text: '🚹'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/277.png',
        text: '⭕'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/278.png',
        text: '❌'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/279.png',
        text: '©'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/280.png',
        text: '®'
    },
    {
        url: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/emoji/281.png',
        text: '™'
    },
]
export default ImEmoji